var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"tenant-upgrade"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 d-flex align-items-center"},[_c('h2',{staticClass:"page-subtitle"},[_vm._v("\n        "+_vm._s(_vm.__('Você não tem acesso'))+"\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"board with-shadowS"})])
}
var staticRenderFns = []

export { render, staticRenderFns }